import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"
import { type VariantProps } from "class-variance-authority"
import cn from "@/v2-ui/utils/utils.cn"

import {
  sliderBaseRangeVariants,
  sliderBaseThumbVariants,
  sliderBaseTrackVariants,
  sliderBaseVariants,
} from "./slider.base.constants"

export type SliderProps = React.ComponentProps<typeof SliderPrimitive.Root> &
  VariantProps<typeof sliderBaseVariants>

const Slider = ({
  className,
  defaultValue,
  value,
  min,
  max,
  size,
  ...props
}: SliderProps) => {
  const _values = React.useMemo(
    () =>
      Array.isArray(value)
        ? value
        : Array.isArray(defaultValue)
          ? defaultValue
          : [min, max],
    [value, defaultValue, min, max],
  )
  return (
    <SliderPrimitive.Root
      data-slot="slider"
      defaultValue={defaultValue}
      value={value}
      min={min}
      max={max}
      className={cn(sliderBaseVariants({ className, size }), className)}
      {...props}
    >
      <SliderPrimitive.Track
        data-slot="slider-track"
        className={sliderBaseTrackVariants({ size })}
      >
        <SliderPrimitive.Range
          data-slot="slider-range"
          className={sliderBaseRangeVariants({ size })}
        />
      </SliderPrimitive.Track>
      {Array.from({ length: _values.length }, (_, index) => (
        <SliderPrimitive.Thumb
          data-slot="slider-thumb"
          key={index}
          className={sliderBaseThumbVariants({ size })}
        />
      ))}
    </SliderPrimitive.Root>
  )
}
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
